import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cd10500"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "face-item__actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_AssignFaceModal = _resolveComponent("AssignFaceModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['face-item', { 'face-item--selected': _ctx.selected }]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select')))
  }, [
    _createVNode(_component_q_avatar, {
      size: "80px",
      color: "grey-3",
      class: "face-item__avatar"
    }, {
      default: _withCtx(() => [
        (_ctx.face.imageUrl)
          ? (_openBlock(), _createBlock(_component_q_img, {
              key: 0,
              src: _ctx.face.imageUrl,
              ratio: 1,
              fit: "cover"
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock(_component_q_icon, {
              key: 1,
              name: "fa fa-user",
              size: "36px",
              color: "grey-5"
            }))
      ]),
      _: 1
    }),
    (_ctx.isGranted('MANAGE_FACES'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_btn, {
            icon: "fa fa-user-plus",
            color: "white",
            flat: "",
            round: "",
            dense: "",
            class: "face-action-btn",
            onClick: _withModifiers(_ctx.openAssignDialog, ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, { delay: 400 }, {
                default: _withCtx(() => [
                  _createTextVNode("Reassign to person")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_q_btn, {
            icon: "fa fa-trash",
            color: "white",
            loading: _ctx.isLoading,
            flat: "",
            round: "",
            dense: "",
            class: "face-action-btn",
            onClick: _withModifiers(_ctx.confirmDelete, ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, { delay: 400 }, {
                default: _withCtx(() => [
                  _createTextVNode("Delete face")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AssignFaceModal, {
      ref: "assignModal",
      "client-id": _ctx.clientId,
      onAssigned: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reassigned', _ctx.face)))
    }, null, 8, ["client-id"])
  ], 2))
}